import "./Sidebar.css";
import "./Calendar.css";
import React, {
  ChangeEvent,
  useContext,
  useEffect,
  useState,
  useMemo,
} from "react";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import { useTranslation } from "react-i18next";
import * as BsIcons from "react-icons/bs";
import { usePreference } from "../../../context/usePreference";
import { LanguageContext } from "../../../context/LanguageContext";
import { PracaContext } from "../../../context/PracaContext";
import { PeriodicityContext } from "../../../context/PeriodicityContext";
import {
  ValidAccessTokenLocalStorage,
  getAccessTokenLocalStorage,
  getChannelOrderLocalStorage,
  getLocDatFinStorage,
  getLocDatIniStorage,
  getlsDescFullStorage,
  getpopErrorStorage,
  handleMsgError,
  handleStartupLanguage,
  handleUserLogOut,
  setLocDatFinStorage,
  setLocDatIniStorage,
  setlangStorage,
  setpopErrorStorage,
} from "../../../context/utils";
import { UserPreferenceContext } from "../../../context/UserPreferenceContext";
import AudienceProvider, {
  AudienceContext,
} from "../../../context/AudienceContext";
import { ChannelsContext } from "../../../context/ChannelsContext";
import { es, ptBR, enUS } from "date-fns/locale";
import { format } from "date-fns";
import { DayPicker } from "react-day-picker";
import Indice from "../Indice/Indice";
import {
  StyledLabel,
  MiniStyledLabel,
  ToggleContainer,
  StyledLabelPeriodo,
} from "./StyledComponents";
import PrintBar from "../Print/PrintBar";
import { openPopout, closePopout } from "../Popout/PopoutManager";
import PrintPage from "../Print/PrintPage";
import ModalSmall from "../ModalSmall";
import Emissora from "../Emissora/Emissora";
import EmissoraColor from "../EmissoraColor/EmissoraColor";
import { UpdatePreferences } from "../../../services/UserService";
import { useAuth } from "../../../context/useAuth";
import { IUserPreferenceDataRequest } from "../../../context/types";
import {
  emissoraColorClick,
  getClassNameNavMenuIcon,
  getClassNameNavPrint,
  getClassNameNavTarget,
  getClassNamePeriodicidade,
  useClassNameSelectedTarget,
  getClassNameSidebarMenu,
  getClassNameSidebarMenuItens,
  getClassNameSidebarMenuNav,
  getDataObjArray,
  getDateForChangeMinute,
  getDateForChangeMinuteIni,
  getDateFormat,
  getHorarioIni,
  getLabelHour,
  getMsgPopError,
  getPracaAbrev,
  getPracaTargets,
  getSideIconByLanguage,
  getstylepracatextnav,
  handlingCurrentDateTime,
  handlingLocDatFin,
  handlingLocDatIni,
  isInValidSelectedDate,
  loadHoursCalendar,
  loadMinutesCalendar,
  openHelp,
  openTermo,
  renderFaIconsFaChevronUp,
  renderFaIconsFaChevronUpForHoraOrHoraMedia,
  renderIconPeridoInicial,
  validAudienceData,
  validDisableBotton,
  validTipoBase,
  validUserPreference,
} from "./SideBarUtils";
import { HandleAudienceTimeDoAudience } from "../../../utils/audienceUtils";
import { ChannelSideBarContext } from "../../../context/Channels/ChannelSideBarContext";
import i18next from "i18next";
import { DateTimeAudienceContext } from "../../../context/DateTimeAudienceContext";
import { useDateTimeAudienceContext } from "../../../hooks/userDateTimeAudienceContext";
import { NetworkAlertContext } from "../../../context/NetworkAlertContext";
import { clickCancelChannel, clickCancelChannelColor, clickSaveChannel, clickSaveChannelColor } from "../Emissora/EmissoraUtil";
import { DivMinuteEnum, DivChartEnum, SelectTypeGridEnum } from '../../../utils/enums';
import { ChartContext } from "../../../context/ChartContext";
import { getMediaCompLocalStorage } from "../MediaComp/MediaCompUtils";

const Sidebar = ({ stateChangePageToChangePassword, DivMinute, CountryId, changeSelectDiv, selectTypeGrid, ...rest }) => {
  const { t, i18n } = useTranslation();
  const auth = useAuth();

  //Context
  const {
    userPreference,
    userTarget,
    userPost,
    doUserPreference,
    updateUserPreference,
    setUserAuthenticated,
    userAuthenticated,
    horaIniCalendar,
    horaFinCalendar,
    setHoraFinCalendar,
    setHoraIniCalendar,
  } = useContext(UserPreferenceContext);
  const { language, doLanguage } = useContext(LanguageContext);
  const { praca, doPraca } = useContext(PracaContext);
  const { doChannels, channels, doChangeChannel, doCancelChangeChannel, doChangeColorChannel } =
    useContext(ChannelsContext);
  const {
    doAudience,
    lastMinute,
    audience,
    doAudienceMedia,
    audienceMediaFirstTable,
    resetQtdMinutos,
  } = useContext(AudienceContext);
  const { doAudienceChart } = useContext(ChartContext);
  const { periodicity, doPeriodicity, changeCountryId } =
    useContext(PeriodicityContext);
  const { doDateTimeAudience } = useContext(DateTimeAudienceContext);
  const { setMsgError, setError, error, msgError } = useContext(NetworkAlertContext);
  const { doAudienceMediaComp } = useContext(AudienceContext);
  //Hook
  const user = usePreference();
  const dateTimeAudienceUser = useDateTimeAudienceContext();
  //State
  const [sendComboValues, setSendComboValues] = useState({
    HrFim: "",
    HrIni: "",
    MinFim: "",
    MinIni: "",
  });
  const [minuteIniSelect, setMinuteIniSelect] = useState<any>(lastMinute);
  const [selectedTarget, setSelectedTarget] = useState<number>();
  const [selectedPraca, setSelectedPraca] = useState<number>();
  const [closePop, setClosePop] = useState<boolean>(false);
  const [showPopout, setShowPopout] = useState<boolean>(false);
  const [popoutWindow, setPopoutWindow] = useState<Window | null>(null);
  const [popoutRoot, setPopoutRoot] = useState<any>(null);
  const [isClosingPopup, setIsClosingPopup] = useState<boolean>(false);
  const [selectedPracaAbrev, setSelectedPracaAbrev] = useState<string>();
  const [sideIcon, setSideIcon] = useState<string | null>(
    getSideIconByLanguage()
  );
  const [icon, setIcon] = useState<string>("header-praca-off");
  const [sidebar, setSidebar] = useState<string>("");
  //const [selectedDate, setSelectedDate] = React.useState<Date>();
  const [selectedDate, setSelectedDate] = React.useState<Date | undefined>(() => {
    const userDate = user.userPreference?.Data;
    return userDate ? new Date(userDate) : undefined;
  });


  const [channelButtonEdit, setChannelButtonEdit] = useState(false);
  const [channelColorSaved, setChannelColorSaved] = useState(false);
  const [buttonChannel, setButtonChannel] = useState(false);
  const [orderTypeChannel, setOrderTypeChannel] = useState(
    getChannelOrderLocalStorage()
  );

  const emissoraColorClickObj = {
    buttonChannel,
    setChannelColorSaved,
    setChannelButtonEdit,
    setButtonChannel,
    doChangeChannel,
    controlNavBar,
    translation: t,
    channelButtonEdit,
    doCancelChangeChannel,
  };

  //Effect
  useEffect(() => {
    const fetchData = async () => {
      callAudience();
      doLanguage();
      doPraca();
      userPost(userPreference);
      doChannels();
      doPeriodicity(user.userPreference.Country.CountryID);
      loadAudienceMediaComp();
    };
    fetchData();
  }, []); 

  useEffect(() => {
    let prevDate = user.userPreference?.Data ? new Date(user.userPreference.Data) : undefined;
    if (selectedDate && prevDate && selectedDate.getTime() !== prevDate.getTime()) {
      changeDate().catch(() => {
        setSelectedDate(prevDate);
      });
    }
  }, [selectedDate]);

  useEffect(() => {
    if (audience == null) setSidebar("emissora");
  }, [audience]);

  useEffect(() => { }, [showPopout]);

  useEffect(() => {
    if (lastMinute) {
      let lastMinuteStr = lastMinute;
      if (typeof lastMinute === 'string' && lastMinute.includes('-')) {
        const parts = lastMinute.split('-');
        lastMinuteStr = (parts.pop() ?? '').trim();
      }
      setHoraFinCalendar(lastMinuteStr);
    }
  }, [lastMinute, setHoraFinCalendar]);

  const changeToMinutePage = () => {

    changeSelectDiv("C", DivChartEnum.Chart);
    changeSelectDiv("M", DivMinuteEnum.Minute);
    resetQtdMinutos();
  }
  //Func
  const handlesendComboChange = (comboName, value) => {
    setSendComboValues((prevState) => ({
      ...prevState,
      [comboName]: value,
    }));
  };
  const showSideicon = (valueLanguage: React.SetStateAction<string | null>) => {
    setSideIcon(valueLanguage);
  };
  const handleclosePop = (value) => {
    if (value === true) {
      closePrint();
    }
  };

  changeCountryId(CountryId ?? user?.userPreference?.Country.CountryID);

  function loadAudienceMediaComp() {
    let MCLocalStorage = getMediaCompLocalStorage();

    if (MCLocalStorage?.autoUpdate) {

      let paramIndice = MCLocalStorage.codIndice ?? '';
      doAudienceMediaComp("", paramIndice);
    }
    else {
      doAudienceMediaComp("", "");
    }
  }

  function isTargetButtonDisabled(targets) {
    return targets?.Targets?.length <= 1;
  }

  async function loadUserPreference() {
    await doUserPreference()
      .then((res) => {
        handleStartupLanguage(i18n, i18next, showSideicon);
      })
      .catch((err) => { });
  }
  async function callAudience() {
    if (DivMinute === DivMinuteEnum.Media) {
      await doAudienceMedia()
        .then((res) => {
          HandleAudienceTimeDoAudience(
            userPreference,
            lastMinute,
            setHoraFinCalendar,
            setHoraIniCalendar,
            audienceMediaFirstTable,
            "callAudience"
          );
        })
        .catch((err) => { });
    } else if (DivMinute === DivMinuteEnum.Analytic) {
      await doAudienceChart()
        .then((res) => {
          HandleAudienceTimeDoAudience(
            userPreference,
            lastMinute,
            setHoraFinCalendar,
            setHoraIniCalendar,
            doAudienceChart,
            "callAudience"
          );
        })
        .catch((err) => { });
    }
    else {
      await doAudience();
    }
  }
  async function changeDate() {
    if (isInValidSelectedDate(selectedDate)) return;

    if (validUserPreference(user.userPreference)) {
      let date = getDateFormat(selectedDate);
      user.userPreference.Data = date;
      const payloadRequest: IUserPreferenceDataRequest = {
        userPreference: user.userPreference,
        data: date,
      };
      if (ValidAccessTokenLocalStorage()) {
        await UpdatePreferences(getAccessTokenLocalStorage(), payloadRequest)
          .then((res) => {
            updateUserPreference(res);
            callAudience();
          })
          .catch((err) => {
            auth.handleDisconnectedUser(err?.response?.data, userAuthenticated);
            handleMsgError(err, true, setMsgError, setError);
            throw err;
          });
        doUserPreference();
      }
    }
  }

  async function changeMinute(strHoraMinuto) {
    await doDateTimeAudience()
      .then((res) => { })
      .catch((err) => { });
    if (user.userPreference !== undefined) {
      let date = getDateForChangeMinute(user?.userPreference, strHoraMinuto);
      let dateFin = format(date, "yyyy-MM-dd'T'HH:mm:ss");
      user.userPreference.Horario = dateFin;

      let dtIni = getHorarioIni(
        isAutoUpdate(),
        new Date(user.userPreference.HorarioIni),
        new Date(user.userPreference.Horario),
        dateTimeAudienceUser.dateTimeAudience
      );
      user.userPreference.HorarioIni = format(dtIni, "yyyy-MM-dd'T'HH:mm:ss");

      const payloadRequest: IUserPreferenceDataRequest = {
        userPreference: user.userPreference,
        hora: dateFin,
      };
      if (ValidAccessTokenLocalStorage()) {
        await UpdatePreferences(getAccessTokenLocalStorage(), payloadRequest)
          .then((res) => {
            updateUserPreference(res);
            callAudience();
          })
          .catch((err) => {
            auth.handleDisconnectedUser(err?.response?.data, userAuthenticated);
            handleMsgError(err, true, setMsgError, setError);
            throw err;
          });

        doUserPreference();
      }
    }
  }

  //ver
  async function changeMinuteIni(minuteIniSelect) {
    await doDateTimeAudience()
      .then((res) => { })
      .catch((err) => { });
    if (validUserPreference(user?.userPreference)) {
      let date = getDateForChangeMinuteIni(userPreference, minuteIniSelect);
      let dateIni = format(date, "yyyy-MM-dd'T'HH:mm:ss");
      user.userPreference.HorarioIni = dateIni;
      const payloadRequest: IUserPreferenceDataRequest = {
        userPreference: user.userPreference,
        horaIni: dateIni,
      };
      if (ValidAccessTokenLocalStorage()) {
        await UpdatePreferences(getAccessTokenLocalStorage(), payloadRequest)
          .then((res) => {
            updateUserPreference(res);
            callAudience();
            setHoraIniCalendar(dateIni.split("T")[1].substring(0, 5));
          })
          .catch((err) => {
            auth.handleDisconnectedUser(err?.response?.data, userAuthenticated);
            handleMsgError(err, true, setMsgError, setError);
            throw err;
          });
        doUserPreference();
      }
    }
  }

  const handleAutoUpdateClick = () => {
    changeAutoUpdate(!isAutoUpdate(), isAutoUpdate());
  };

  function ToggleSwitch({ isMini }) {
    function handleOnChange(e: ChangeEvent<HTMLInputElement>) {
      changeAutoUpdate(!isAutoUpdate(), isAutoUpdate());
    }
    function handleOnChangeMini(e: ChangeEvent<HTMLInputElement>) {
      controlNavBar("");
      changeAutoUpdate(!isAutoUpdate(), isAutoUpdate());
    }
    if (!isMini) {
      return (
        <StyledLabel htmlFor="checkbox" checked={isAutoUpdate()}>
          <input
            id="checkbox"
            type="checkbox"
            checked={isAutoUpdate()}
            onChange={handleOnChange}
            style={{
              width: "12px",
              height: "12px",
              borderRadius: "12px",
              backgroundColor: "#69df00",
              display: "inline-block",
              marginLeft: "20px"
            }}
          />
        </StyledLabel>
      );
    } else {
      return (
        <MiniStyledLabel htmlFor="checkboxMini" checked={isAutoUpdate()}>
          <input
            id="checkboxMini"
            type="checkbox"
            checked={isAutoUpdate()}
            onChange={handleOnChangeMini}
            style={{
              width: "12px",
              height: "12px",
              borderRadius: "12px",
              backgroundColor: "#69df00",
              display: "inline-block",
              marginLeft: "20px"
            }}
          />
        </MiniStyledLabel>
      );
    }
  }

  function isAutoUpdate(): boolean {
    return Boolean(user?.userPreference?.ChangeAutoUpdate);
  }

  function controlNavBar(component: string) {
    component !== sidebar ? setSidebar(component) : setSidebar("");
    component === "praca" && sidebar !== "praca"
      ? setIcon("header-praca-on")
      : setIcon("header-praca-off");
  }

  async function changeAutoUpdate(
    checkedCurrent: boolean,
    checkedBefore: boolean
  ) {
    let HorIni: string | null = null;
    let HorFin: string | null = null;

    if (!checkedCurrent) {
      //recarregar datas
      let DefDate = new Date();
      let DtFin = new Date();
      let DtIni = new Date();
      const LocDatIniStorage = getLocDatIniStorage();
      const LocDatFinStorage = getLocDatFinStorage();

      //HorFin
      let resultLocDatFin = handlingLocDatFin(
        LocDatFinStorage,
        DtFin,
        DefDate,
        HorFin,
        user
      );
      DtFin = resultLocDatFin.DtFin;
      HorFin = resultLocDatFin.HorFin;
      HorFin = handlingCurrentDateTime(
        checkedCurrent,
        checkedBefore,
        !isAutoUpdate(),
        HorFin,
        user
      );

      //HorIni
      let resultLocDatIni = handlingLocDatIni(
        LocDatIniStorage,
        DtIni,
        DtFin,
        HorIni,
        user,
        dateTimeAudienceUser.dateTimeAudience
      );
      HorIni = resultLocDatIni.HorIni;
    } else {
      HorFin = handlingCurrentDateTime(
        checkedCurrent,
        checkedBefore,
        isAutoUpdate(),
        HorFin,
        user
      );
      //salvar datas
      setSelectedDate(undefined);
    }
    user.userPreference.HorarioIni = HorIni ?? user.userPreference.HorarioIni; //IBOPE HOUR
    user.userPreference.Horario = HorFin;
    setLocDatIniStorage(user.userPreference.HorarioIni);
    setLocDatFinStorage(user.userPreference.Horario);
    user.userPreference.ChangeAutoUpdate = checkedCurrent;
    const payloadRequest: IUserPreferenceDataRequest = {
      userPreference: user.userPreference,
      autoUpdate: checkedCurrent,
      hora: HorFin,
      horaIni: HorIni,
    };

    if (ValidAccessTokenLocalStorage()) {
      await UpdatePreferences(getAccessTokenLocalStorage(), payloadRequest)
        .then((res) => {
          updateUserPreference(res);
          doChannels();
          callAudience();
        })
        .catch((err) => {
          auth.handleDisconnectedUser(err?.response?.data, userAuthenticated);
          handleMsgError(err, true, setMsgError, setError);
        });
    }
  }
  async function changeLanguage(lang: string, id: string | null) {
    lang = lang.toLowerCase();
    setlangStorage(lang);
    if (await i18n.changeLanguage(lang)) {
      showSideicon(lang);
    }
    if (id !== null) {
      const payloadRequest: IUserPreferenceDataRequest = {
        userPreference: user.userPreference,
        idLanguage: id,
      };
      if (ValidAccessTokenLocalStorage()) {
        await UpdatePreferences(getAccessTokenLocalStorage(), payloadRequest)
          .then((res) => {
            updateUserPreference(res);
          })
          .catch((err) => {
            auth.handleDisconnectedUser(err?.response?.data, userAuthenticated);
            handleMsgError(err, true, setMsgError, setError);
          });
      }
    }
  }

  function getLanguageDaypiker() {
    let lang;
    switch (i18n?.language?.toUpperCase()) {
      case "pt-BR".toUpperCase():
        lang = ptBR;
        break;
      case "es-ES".toUpperCase():
        lang = es;
        break;
      case "en-US".toUpperCase():
        lang = enUS;
        break;
      default:
        lang = enUS;
        break;
    }
    return lang;
  }

  async function changePraca(praca) {
    setSelectedPraca(praca.Id);
    setSelectedPracaAbrev(praca.Abrev);

    let currentTarget = user?.userPreference?.Target;
    const onlyTargetFromPraca = praca?.Targets?.[0];

    if (
      praca?.Targets?.length === 1 || praca?.Targets?.length &&
      currentTarget?.Id !== onlyTargetFromPraca?.Id
    ) {
      currentTarget = { ...onlyTargetFromPraca };
    }

    const payloadRequest: IUserPreferenceDataRequest = {
      userPreference: {
        ...user.userPreference,
        Praca: praca,
        Target: currentTarget,
      },
    };

    if (ValidAccessTokenLocalStorage()) {
      const res = await UpdatePreferences(getAccessTokenLocalStorage(), payloadRequest);
      if (res?.data) {
        updateUserPreference(res);
        await userPost(res.data);
      }
      await doChannels();
      await callAudience();
      loadAudienceMediaComp();
      resetQtdMinutos();
    }
  }

  async function changeTarget(id: number) {
    setSelectedTarget(id);
    const payloadRequest: IUserPreferenceDataRequest = {
      userPreference: user.userPreference,
      target: id,
    };
    if (ValidAccessTokenLocalStorage()) {
      const res = await UpdatePreferences(getAccessTokenLocalStorage(), payloadRequest);
      if (res?.data) {
        userPost(res.data);
      }
      await callAudience();
    }
  }

  async function changePeriodo(id: number) {
    const payloadRequest: IUserPreferenceDataRequest = {
      userPreference: user.userPreference,
      periodo: id,
    };
    if (ValidAccessTokenLocalStorage()) {
      await UpdatePreferences(getAccessTokenLocalStorage(), payloadRequest)
        .then((res) => {
          updateUserPreference(res);
          callAudience();
        })
        .catch((err) => {
          auth.handleDisconnectedUser(err?.response?.data, userAuthenticated);
          handleMsgError(err, true, setMsgError, setError);
        });
    }
  }

  async function changeOrdenacao(id: number) {
    const payloadRequest: IUserPreferenceDataRequest = {
      userPreference: user.userPreference,
      ordem: id,
    };
    if (ValidAccessTokenLocalStorage()) {
      await UpdatePreferences(getAccessTokenLocalStorage(), payloadRequest)
        .then((res) => {
          updateUserPreference(res);
          callAudience();
        })
        .catch((err) => {
          auth.handleDisconnectedUser(err?.response?.data, userAuthenticated);
          handleMsgError(err, true, setMsgError, setError);
        });
    }
  }

  async function changeTipoBase(tipoBase: number) {
    if (validTipoBase(user?.userPreference, tipoBase)) {
      const payloadRequest: IUserPreferenceDataRequest = {
        userPreference: user.userPreference,
        tipoBase: tipoBase,
      };
      if (ValidAccessTokenLocalStorage()) {
        await UpdatePreferences(getAccessTokenLocalStorage(), payloadRequest)
          .then((res) => {
            doChannels();
            callAudience();
          })
          .catch((err) => {
            auth.handleDisconnectedUser(err?.response?.data, userAuthenticated);
            handleMsgError(err, true, setMsgError, setError);
          });
        await doUserPreference();
      }
    }
  }

  async function doLogout() {
    handleUserLogOut();
    setUserAuthenticated(false);
  }

  function openMedia() {
    controlNavBar("hora_media");
  }

  function openPrintBar() {
    let comboHoras = sendComboValues;
    if (validAudienceData(audience)) {
      let timeIni = audience[audience.length - 1][1];
      let timeFim = audience[0][1];

      handlesendComboChange("HrIni", timeIni.split(":")[0]);
      handlesendComboChange("MinIni", timeIni.split(":")[1]);
      handlesendComboChange("HrFim", timeFim.split(":")[0]);
      handlesendComboChange("MinFim", timeFim.split(":")[1]);

      comboHoras = {
        HrFim: timeFim.split(":")[0],
        HrIni: timeIni.split(":")[0],
        MinFim: timeFim.split(":")[1],
        MinIni: timeIni.split(":")[1],
      };
      setSendComboValues(comboHoras);
    }
    controlNavBar("print");
  }

  async function openPrint() {
    // Verifica se a janela foi fechada manualmente e atualiza o estado
    if (popoutWindow && popoutWindow.closed) {
      setPopoutWindow(null);
      setPopoutRoot(null);
      setShowPopout(false);
    }
    
    // Se já estiver aberto, primeiro fecha e então reabre com os dados mais recentes
    if (showPopout && popoutWindow && !popoutWindow.closed) {
      closePrint();
      // Aguarda mais tempo para garantir que o fechamento seja completo
      await new Promise((res) => setTimeout(res, 200));
      
      // Verifica se realmente foi fechado
      if (showPopout) {
        setShowPopout(false);
        setPopoutWindow(null);
        setPopoutRoot(null);
      }
    }

    const features = 'width=900,height=700,menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes';
    const name = 'RealtimePrint_Main';

    try {
      const { child, root } = await openPopout({ name, features, title: 'Realtime', containerId: 'realtime-print-root-' + name }, (
        <AudienceProvider>
          <PrintPage
            pp_user={user}
            comboHoras={sendComboValues}
            data={user.userPreference.Data.split("T")[0]}
            pp_channels={channels}
            onClose={handleclosePop}
          ></PrintPage>
        </AudienceProvider>
      ));

      setPopoutWindow(child);
      setPopoutRoot(root);
      setShowPopout(true);
      
      // Adiciona listener para detectar quando a janela é fechada manualmente
      const checkClosed = () => {
        // Só verifica se não estamos fechando programaticamente
        if (!isClosingPopup && child && child.closed) {
          setPopoutWindow(null);
          setPopoutRoot(null);
          setShowPopout(false);
        } else if (child && !child.closed) {
          setTimeout(checkClosed, 500); // Verifica a cada 500ms
        }
      };
      setTimeout(checkClosed, 1000); // Primeira verificação após 1 segundo
      
      controlNavBar('print');
    } catch (err) {
      if ((err as Error).message === 'POPUP_BLOCKED') {
        setMsgError(t('error.popupBlocked') || 'Popup blocked');
      } else {
        setMsgError(t('error.unableToOpenPopout') || 'Unable to open popout');
      }
      setError(true);
    }
  }

  function closePrint() {
    // Marca que estamos fechando programaticamente
    setIsClosingPopup(true);
    
    // Salva referências antes de limpar estados
    const currentPopoutRoot = popoutRoot;
    const currentPopoutWindow = popoutWindow;
    
    // Se perdemos a referência, tenta encontrar a janela pelo nome
    let windowToClose = currentPopoutWindow;
    if (!windowToClose || windowToClose.closed) {
      // Tenta encontrar a janela aberta com o nome conhecido
      try {
        windowToClose = window.open('', 'RealtimePrint_Main', '');
      } catch (e) {
        // ignore
      }
    }
    
    // Desmonta e fecha a janela popout externa
    try {
      if (currentPopoutRoot && windowToClose && !windowToClose.closed) {
        closePopout(currentPopoutRoot, windowToClose);
      } else if (windowToClose && !windowToClose.closed) {
        windowToClose.close();
      }
    } catch (e) {
      // ignore
    }
    
    // Limpa todos os estados
    setPopoutRoot(null);
    setPopoutWindow(null);
    setShowPopout(false);
    setIsClosingPopup(false);
    
    // Força o foco de volta para a janela principal
    window.focus();

    let popError: string = getMsgPopError(getpopErrorStorage());
    if (popError !== "") {
      setMsgError(popError);
      setError(true);
      setpopErrorStorage("");
    }
  }

  const hourChange = (event) => {
    // Salva o valor anterior da hora
    const prevHour = user.userPreference.Horario.split("T")[1].split(":")[0];
    const prevValue = prevHour + ":" + user.userPreference.Horario.split("T")[1].split(":")[1];

    const strHoraMinuto = event.target.value +
      ":" +
      user.userPreference.Horario.split("T")[1].split(":")[1];

    changeMinute(strHoraMinuto)
      .then((res) => {
      })
      .catch((err) => {
        // Se der erro, volta ao valor anterior
        changeMinute(prevValue);
        event.target.value = prevHour;
      });
  };

  const minutesChange = (event) => {
    // Salva o valor anterior dos minutos
    const prevMinute = user.userPreference.Horario.split("T")[1].split(":")[1];
    const prevValue = `${user.userPreference.Horario.split("T")[1].split(":")[0]}:${prevMinute}`;

    const strHoraMinuto = `${user.userPreference.Horario.split("T")[1].split(":")[0]}:${event.target.value}`;
    changeMinute(strHoraMinuto)
      .then((res) => {
      })
      .catch((err) => {
        // Se der erro, volta ao valor anterior
        changeMinute(prevValue);
        event.target.value = prevMinute;
      });
  };

  const hourIniChange = (event) => {
    // Salva o valor anterior da hora inicial
    const prevHourIni = user.userPreference.HorarioIni.split("T")[1].split(":")[0];
    const prevValue = prevHourIni + ":" + user.userPreference.HorarioIni.split("T")[1].split(":")[1];

    let newValue;
    if (minuteIniSelect === undefined) {
      newValue = event.target.value + ":" + user.userPreference.HorarioIni.split("T")[1].split(":")[1];
    } else {
      newValue = event.target.value + ":" + minuteIniSelect.split(":")[1];
    }

    changeMinuteIni(newValue)
      .then((res) => {})
      .catch((err) => {
        // Se der erro, volta ao valor anterior
        changeMinuteIni(prevValue);
        event.target.value = prevHourIni;
      });
  };

  const minutesIniChange = (event) => {
    // Salva o valor anterior dos minutos iniciais
    const prevMinuteIni = user.userPreference.HorarioIni.split("T")[1].split(":")[1];
    const prevValue = `${user.userPreference.HorarioIni.split("T")[1].split(":")[0]}:${prevMinuteIni}`;

    let newValue;
    if (minuteIniSelect === undefined) {
      newValue =
        user.userPreference.HorarioIni.split("T")[1].split(":")[0] +
        ":" +
        event.target.value;
    } else {
      newValue = minuteIniSelect.split(":")[0] + ":" + event.target.value;
    }

    changeMinuteIni(newValue)
      .then((res) => {})
      .catch((err) => {
        // Se der erro, volta ao valor anterior
        changeMinuteIni(prevValue);
        event.target.value = prevMinuteIni;
      });
  };

  const target = (event) => {
    setSelectedTarget(event.target.value);
    changeTarget(event.target.value);
  };

  function HandleChangeOrdenacao(e: ChangeEvent<HTMLInputElement>) {
    changeOrdenacao(userPreference.Ordenacao === 0 ? 1 : 0);
  }

  function getDisplayStyleForTarget(targets: any): React.CSSProperties {
    return { display: isTargetButtonDisabled(targets) ? "none" : "block" };
  }

  let hoursCalendar: string[] = [],
    minutesCalendar: string[] = [];
  hoursCalendar = loadHoursCalendar();
  minutesCalendar = loadMinutesCalendar();

  let pracaTargets = getPracaTargets(praca, userPreference);

  const objChannelSideBarContextMemo = useMemo(
    () => ({
      channelButtonEdit,
      setChannelButtonEdit,
      channelColorSaved,
      setChannelColorSaved,
      buttonChannel,
      setButtonChannel,
      orderTypeChannel,
      setOrderTypeChannel,
    }),
    [channelButtonEdit, orderTypeChannel, channelColorSaved, buttonChannel]
  );
  const MenuBarHamburger = (
    <Link to="#" className="menu-bars" key="menu-bars">
      <FaIcons.FaBars onClick={() => controlNavBar("menu")} />
    </Link>
  );

  const BackBtn = (
    <div style={{ float: "left" }}>
      <button type="submit"
        onClick={() => changeToMinutePage()}
        style={{ border: "0px", padding: "0px", background: "none", outline: "none", marginRight: "10px", color: "#FFF", fontWeight: 300, fontSize: "17px" }}>
        <span style={{ display: "block", float: "left", color: "#767677", marginRight: "5px" }}><FaIcons.FaChevronLeft onClick={() => controlNavBar("menu")} /></span>
        <span>{t("settings.back")}</span>
      </button>
    </div>

  );
  const DivMinuteAtivo = DivMinuteEnum.Image;
  const PracaBtn = (
    <div style={{ display: "inline", position: "relative" }}>
      <button
        onClick={() => controlNavBar("praca")}
        style={{
          border: "0px",
          padding: "0",
          paddingLeft: "12px",
          background: "none",
          outline: "none",
          marginRight: "10px",
          textTransform: "none",
          fontSize: "17px",
          fontWeight: 300,
        }}
      >
        <span style={{ color: "white", fontSize: "19px" }}>
          {getPracaAbrev(selectedPracaAbrev, userPreference)}
        </span>
        <i className={icon}></i>
      </button>
      <span
        style={{
          color: "#c3980b",
          fontSize: "8px",
          position: "absolute",
          right: "26px",
          bottom: "-20px",
          fontWeight: "700",
          letterSpacing: "1.5px",
        }}
      >
        RT
      </span>
    </div>
  );
  const MinuteMenu = (<div className="minuteMenu">
    <button
      onClick={() =>
        DivMinute === DivMinuteEnum.Media ? openMedia() : controlNavBar("hora")
      }
      disabled={validDisableBotton(DivMinute, isAutoUpdate())}
      style={{
        border: "0px",
        padding: "0",
        paddingLeft: "12px",
        background: "none",
        outline: "none",
        marginRight: "10px",
        textTransform: "none",
        fontWeight: 300
      }}
    >
      <span className="indiceBtnSize" >
        {getLabelHour(
          DivMinute,
          horaIniCalendar,
          horaFinCalendar
        )}
      </span>
      <span id="iconArrowDown"
        className="iconArrowDown"
        hidden={validDisableBotton(DivMinute, isAutoUpdate())}
      >
        {renderFaIconsFaChevronUpForHoraOrHoraMedia(sidebar)}
      </span>
    </button>
  </div>
  );
  const TargetBtn = (
    <button
      onClick={() => controlNavBar("target")}
      disabled={isTargetButtonDisabled(pracaTargets)}
      style={{
        border: "0px",
        padding: "0",
        paddingLeft: "12px",
        background: "none",
        outline: "none",
        marginRight: "10px",
        textTransform: "none"
      }}
    >
      <i className={useClassNameSelectedTarget()}></i>
      <span className="iconArrowDown"
        style={getDisplayStyleForTarget(pracaTargets)}>
        {renderFaIconsFaChevronUp(sidebar, "target")}
      </span>
    </button>
  );
  const IndiceBtn = (
    <button
      onClick={() => controlNavBar("indice")}
      style={{
        border: "0px",
        padding: "0",
        paddingLeft: "12px",
        background: "none",
        outline: "none",
        marginRight: "10px",
        textTransform: "none",
        fontWeight: 300
      }}
    >
      <span className="indiceBtnSize" >
        {" "}
        {getlsDescFullStorage()}{" "}
      </span>
      <span className="iconArrowDown">
        {renderFaIconsFaChevronUp(sidebar, "indice")}
      </span>
    </button>
  );
  const AutoUpdateBtn = (
    <button
      onClick={() => handleAutoUpdateClick()}
      style={{
        border: "0px",
        padding: "0",
        background: "none",
        outline: "none",
        marginRight: "10px",
        textTransform: "none",
        fontWeight: 300
      }}
    >
      <span className="autoUpdateLabel">
        {t("settings.autoUpdateStatus")}
      </span>
      <ToggleSwitch isMini={true}></ToggleSwitch>
    </button>
  );
  return (
    <div data-testid="divSidebar" style={{ height: "50px" }}>
      <menu className="menu" style={{
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "inline-block"
      }}>
        {DivMinute === DivMinuteAtivo || SelectTypeGridEnum.Analytic == selectTypeGrid ? (
          <>
            {BackBtn}
            {MinuteMenu}
            <div style={{
              float: "right",
              fontSize: "inherit"
            }}>
              {TargetBtn}
              {IndiceBtn}
              {PracaBtn}
            </div>
          </>
        ) : (
          <>
            {MenuBarHamburger}
            {PracaBtn}
            {MinuteMenu}
            <div style={{
              float: "right",
              fontSize: "inherit"
            }}>
              {TargetBtn}
              {IndiceBtn}
              {AutoUpdateBtn}
            </div>
          </>
        )}

        <nav id="Menu"
          className={getClassNameSidebarMenu(sidebar)}
          style={{
            marginBottom: '20px',
            paddingBottom: '50px'
          }}
        >
          <header>
            <h1>Menu</h1>
            <button onClick={() => controlNavBar("")}>
              {t("settings.close")}
            </button>
          </header>

          <ul className={getClassNameSidebarMenuItens(sidebar)}>
            <li className="nav-text">
              <ToggleContainer>
                <span>{t("settings.autoUpdate")}</span>
                <ToggleSwitch isMini={false}></ToggleSwitch>
              </ToggleContainer>
            </li>
          </ul>

          <ul className={getClassNameSidebarMenuItens(sidebar)}>
            <Link to="#" className="link" key="c">
              <div style={{ display: "grid" }}>
                <li
                  value="c"
                  className="nav-text"
                  onClick={() => changeTipoBase(0)}
                >
                  <span>{t("base.column")}</span>

                  <span
                    className={getClassNameNavMenuIcon(
                      Number(user.userPreference?.TipoBase),
                      0
                    )}
                  >
                    <BsIcons.BsCheckLg />
                  </span>
                </li>
                <li
                  value="r"
                  className="nav-text"
                  onClick={() => changeTipoBase(1)}
                >
                  <span>{t("base.row")}</span>

                  <span
                    className={getClassNameNavMenuIcon(
                      Number(user.userPreference?.TipoBase),
                      1
                    )}
                  >
                    <BsIcons.BsCheckLg />
                  </span>
                </li>
              </div>
            </Link>
          </ul>

          <ul
            id="languageOptions"
            className={sidebar ? "nav-menu-items" : "nav-menu-other"}
          >
            {language?.map((item) => {
              return (
                <Link to="#" className="link" key={item.Id}>
                  <div style={{ display: "grid" }}>
                    <li
                      id={`languageOption_${item.Pref.toLowerCase()}`}
                      onClick={() => changeLanguage(item.Pref.toLowerCase(), item.Id)}
                      className="nav-text"
                    >
                      <span>
                        {item.Desc.charAt(0) + item.Desc.slice(1).toLowerCase()}
                      </span>
                      <span
                        className={getClassNameNavMenuIcon(
                          userPreference?.Language?.Id,
                          item.Id
                        )}
                      >
                        <BsIcons.BsCheckLg />
                      </span>
                    </li>
                  </div>
                </Link>
              );
            })}
          </ul>

          {/* Emissora Botao Menu */}
          <ul id="emissoras" className={getClassNameSidebarMenuItens(sidebar)}>
            <Link to="#" className="link">
              <div style={{ display: "grid" }}>
                <li
                  style={{ paddingRight: "0px" }}
                  className="nav-text"
                  onClick={() => controlNavBar("emissora")}
                >
                  <span>{t("secret.settings.columns")}</span>
                  <i className="emissoraIcon"></i>
                </li>
              </div>
            </Link>
          </ul>

          <ul id="termo" className={getClassNameSidebarMenuItens(sidebar)}>
            <Link to="#" className="link">
              <div style={{ display: "grid" }}>
                <li className="nav-text" onClick={() => openTermo(user)}>
                  <span>{t("settings.tos")}</span>
                </li>
              </div>
            </Link>

            <Link to="#" className="link">
              <div style={{ display: "grid" }}>
                <li className="nav-text" onClick={() => openHelp(user)}>
                  <span>{t("settings.help")}</span>
                </li>
              </div>
            </Link>
          </ul>

          <ul id="menuitens"
            className={getClassNameSidebarMenuItens(sidebar)}
            style={{ marginBottom: "0px" }}
          >
            <Link to="#" className="link">
              <div style={{ display: "grid" }}>
                <li
                  style={{ paddingRight: "0px" }}
                  className="nav-text"
                  onClick={() => openPrintBar()}
                >
                  <span>{t("settings.print")}</span>
                  <i className="emissoraIcon"></i>
                </li>
              </div>
            </Link>

            <Link to="#" className="link">
              <a className="link">
                <div style={{ display: "grid" }}>
                  <li className="nav-text" onClick={() => stateChangePageToChangePassword(true)}>
                    <span>{t("settings.changePassword")}</span>
                  </li>
                </div>
              </a>
            </Link>

            <Link to="#" className="link">
              <a className="link">
                <div style={{ display: "grid" }}>
                  <li className="nav-text" onClick={() => doLogout()}>
                    <span>{t("settings.logout")}</span>
                  </li>
                </div>
              </a>{" "}
            </Link>
          </ul>
        </nav>

        <nav id="praca"
          className={getClassNameSidebarMenuNav(sidebar, "praca")}
          style={{
            [DivMinute === DivMinuteAtivo ? "right" : "left"]: "0"
          }}>
          <header>
            <h1>{t("secret.groups.title")}</h1>
            <button onClick={() => controlNavBar("")}>
              {t("settings.close")}
            </button>
          </header>
          <h2 className="realtime">Realtime</h2>
          <ul className="nav-menu-items-praca">
            {praca?.map((item, index) => {
              return (
                <Link to="#" className="link" key={item.Id}>
                  <div style={{ display: "grid" }}>
                    <li
                      style={{ color: item.PracaCor }}
                      key={item.Id}
                      onClick={() => changePraca(item)}
                      className="nav-text"
                    >
                      <span
                        className="nav-text-praca"
                        style={getstylepracatextnav(item.PracaCor)}
                      >
                        {item.Desc.split("REAL TIME", 1) +
                          " (" +
                          item.Abrev +
                          ")"}
                      </span>
                      {selectedPraca !== undefined ? (
                        <span
                          className={getClassNameNavMenuIcon(
                            selectedPraca,
                            item.Id
                          )}
                        >
                          <BsIcons.BsCheckLg />
                        </span>
                      ) : (
                        <span
                          className={getClassNameNavMenuIcon(
                            userPreference?.Praca.Id,
                            item.Id
                          )}
                        >
                          <BsIcons.BsCheckLg />
                        </span>
                      )}
                    </li>
                  </div>
                </Link>
              );
            })}
          </ul>
        </nav>

        <nav id="hora"
          style={{ left: "50%", marginLeft: "-150px" }}
          className={getClassNameSidebarMenuNav(sidebar, "hora")}
        >
          <header>
            <h1>{t("rows.hour")}</h1>
            <button onClick={() => controlNavBar("")}>
              {t("settings.close")}
            </button>
          </header>
          <h2 className="realtime">{t("rows.date")}</h2>
          <ul className="nav-menu-hora">
            <div style={{ marginLeft: "-10px" }}>
              <div className="DayPicker-NavBar">
                <span className="DayPicker-NavButton DayPicker-NavButton--prev"></span>
                <span className="DayPicker-NavButton DayPicker-NavButton--next"></span>
              </div>
              <DayPicker
                id="DayPMedia"
                mode="single"
                selected={selectedDate}
                onSelect={setSelectedDate}
                showOutsideDays={true}
                disabled={(day) => day > new Date()}
                weekStartsOn={0}
                locale={getLanguageDaypiker()}
              />
            </div>
          </ul>
          <h2 className="realtime">{t("rows.endingTime")}</h2>
          <ul className="nav-menu-hour-minute">
            <div className="selectDivMinute">
              <div className="selectEndMinute">
                <label>{t("rows.hour")}</label>
                <select onChange={hourChange} style={{ width: "100%" }}>
                  {getDataObjArray(hoursCalendar).map((option) =>
                    lastMinute?.split(":")[0] === option.DataValueArray ? (
                      <option
                        selected
                        value={option.DataValueArray}
                        key={option.ValueId}
                      >
                        {option.DataValueArray}
                      </option>
                    ) : (
                      <option
                        value={option.DataValueArray}
                        key={option.ValueId}
                      >
                        {option.DataValueArray}
                      </option>
                    )
                  )}
                </select>
              </div>
              <div className="selectEndMinute">
                <label>{t("rows.minute")}</label>
                <select onChange={minutesChange} style={{ width: "100%" }}>
                  {getDataObjArray(minutesCalendar).map((option) =>
                    lastMinute?.split(":")[1] === option.DataValueArray ? (
                      <option
                        selected
                        value={option.DataValueArray}
                        key={option.ValueId}
                      >
                        {option.DataValueArray}
                      </option>
                    ) : (
                      <option
                        value={option.DataValueArray}
                        key={option.ValueId}
                      >
                        {option.DataValueArray}
                      </option>
                    )
                  )}
                </select>
              </div>
            </div>
          </ul>
        </nav>

        {/* ***** FILTROS MEDIA ***** */}
        <nav id="hora_media"
          style={{ left: "50%", marginLeft: "-150px" }}
          className={getClassNameSidebarMenuNav(sidebar, "hora_media")}
        >
          <header>
            <h1>{t("secret.rows.mergeRows")}</h1>
            <button onClick={() => controlNavBar("")}>
              {t("settings.close")}
            </button>
          </header>

          {/* ***** CALENDARIO ***** */}
          {!isAutoUpdate() ? (
            <>
              <h2 className="realtime">{t("rows.date")}</h2>
              <ul className="nav-menu-hora">
                <div style={{ marginLeft: "-10px" }}>
                  <div className="DayPicker-NavBar">
                    <span className="DayPicker-NavButton DayPicker-NavButton--prev"></span>
                    <span className="DayPicker-NavButton DayPicker-NavButton--next"></span>
                  </div>
                  <DayPicker
                    mode="single"
                    selected={selectedDate}
                    onSelect={setSelectedDate}
                    showOutsideDays={true}
                    disabled={(day) => day > new Date()}
                    weekStartsOn={0}
                    locale={getLanguageDaypiker()}
                  />
                </div>
              </ul>
            </>
          ) : (
            <></>
          )}

          {/* ***** HORA INICIAL ***** */}
          <h2 className="realtime">{t("rows.startingTime")}</h2>
          <ul className="nav-menu-hour-minute">
            <div className="selectDivMinute">
              <div className="selectEndMinute">
                <label>{t("rows.hour")}</label>
                <select onChange={hourIniChange} style={{ width: "100%" }}>
                  {getDataObjArray(hoursCalendar).map((option) =>
                    horaIniCalendar?.split(":")[0] === option.DataValueArray ? (
                      <option
                        selected
                        value={option.DataValueArray}
                        key={option.ValueId}
                      >
                        {option.DataValueArray}
                      </option>
                    ) : (
                      <option
                        value={option.DataValueArray}
                        key={option.ValueId}
                      >
                        {option.DataValueArray}
                      </option>
                    )
                  )}
                </select>
              </div>
              <div className="selectEndMinute">
                <label>{t("rows.minute")}</label>
                <select onChange={minutesIniChange} style={{ width: "100%" }}>
                  {getDataObjArray(minutesCalendar).map((option) =>
                    horaIniCalendar?.split(":")[1] === option.DataValueArray ? (
                      <option
                        selected
                        value={option.DataValueArray}
                        key={option.ValueId}
                      >
                        {option.DataValueArray}
                      </option>
                    ) : (
                      <option
                        value={option.DataValueArray}
                        key={option.ValueId}
                      >
                        {option.DataValueArray}
                      </option>
                    )
                  )}
                </select>
              </div>
            </div>
          </ul>

          {/* ***** HORA FINAL ***** */}
          {!isAutoUpdate() ? (
            <>
              <h2 className="realtime">{t("rows.endingTime")}</h2>
              <ul className="nav-menu-hour-minute">
                <div className="selectDivMinute">
                  <div className="selectEndMinute">
                    <label>{t("rows.hour")}</label>
                    <select onChange={hourChange} style={{ width: "100%" }}>
                      {getDataObjArray(hoursCalendar).map((option) =>
                        horaFinCalendar?.split(":")[0] ===
                          option.DataValueArray ? (
                          <option
                            selected
                            value={option.DataValueArray}
                            key={option.ValueId}
                          >
                            {option.DataValueArray}
                          </option>
                        ) : (
                          <option
                            value={option.DataValueArray}
                            key={option.ValueId}
                          >
                            {option.DataValueArray}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                  <div className="selectEndMinute">
                    <label>{t("rows.minute")}</label>
                    <select onChange={minutesChange} style={{ width: "100%" }}>
                      {getDataObjArray(minutesCalendar).map((option) =>
                        horaFinCalendar?.split(":")[1] ===
                          option.DataValueArray ? (
                          <option
                            selected
                            value={option.DataValueArray}
                            key={option.ValueId}
                          >
                            {option.DataValueArray}
                          </option>
                        ) : (
                          <option
                            value={option.DataValueArray}
                            key={option.ValueId}
                          >
                            {option.DataValueArray}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                </div>
              </ul>
            </>
          ) : (
            <></>
          )}

          {/* ***** PERIODICIDADE ***** */}
          <h2 className="realtime">{t("rows.interval")}</h2>
          <ul className="nav-menu-hour-minute" style={{ paddingLeft: "20px" }}>
            <div className="divPeriodicity">
              {periodicity?.map((periodo) => (
                <div className="divRadioPeriodicity" key={periodo.Id}>
                  <label className="lblPeriodicity">
                    <span
                      className={getClassNamePeriodicidade(
                        userPreference,
                        periodo.Id
                      )}
                    >
                      <BsIcons.BsCheckLg style={{ color: "#0d99db" }} />
                    </span>
                    <input
                      className="cellPeriodicity"
                      type="radio"
                      onClick={() => changePeriodo(periodo.Id)}
                      value={periodo.Id}
                      name={periodo.Valor}
                    />
                    &nbsp;
                    {periodo.Valor}
                  </label>
                </div>
              ))}
            </div>

            <div className="divOrdenacao">
              <span style={{ margin: "10px" }}>{t("rows.startingTime")}</span>

              <StyledLabelPeriodo
                htmlFor="checkboxOrd"
                checked={userPreference?.Ordenacao}
              >
                <input
                  id="checkboxOrd"
                  type="checkbox"
                  checked={userPreference?.Ordenacao}
                  onChange={HandleChangeOrdenacao}
                />
              </StyledLabelPeriodo>
              {renderIconPeridoInicial(userPreference?.Ordenacao)}
              <span style={{ margin: "10px" }}>{t("rows.endingTime")}</span>
            </div>
          </ul>
        </nav>

        <nav id="target" className={getClassNameNavTarget(sidebar, "target")}>
          <div style={{ marginBottom: "20px" }}>
            <header>
              <h1>{t("secret.classes.title")}</h1>
              <button onClick={() => controlNavBar("")}>
                {t("settings.close")}
              </button>
            </header>
            <ul className="nav-menu-items-target">
              <div className="nav-menu-items-target-select">
                <select style={{ width: "100%" }} onChange={target} value={userTarget?.Target?.Id}>
                  {pracaTargets !== undefined ? (
                    pracaTargets.Targets?.map((item, index) => {
                      return userPreference?.Target.Id === item.Id ? (
                        <option selected value={item.Id} key={item.Id}>
                          {item.Desc}
                        </option>
                      ) : (
                        <option value={item.Id}>{item.Desc}</option>
                      );
                    })
                  ) : (
                    <></>
                  )}
                </select>
              </div>
            </ul>
          </div>
        </nav>

        <nav id="indice" className={getClassNameNavTarget(sidebar, "indice")}>
          <div>
            <header>
              <h1>{t("secret.vars.title")}</h1>
              <button onClick={() => controlNavBar("")}>
                {t("settings.close")}
              </button>
            </header>
            <ul className="nav-menu-items-praca">
              <Indice
                pri={t("secret.vars.input1")}
                sec={t("secret.vars.input2")}
                DivMinute={DivMinute}
                selectTypeGrid={selectTypeGrid}
              />
            </ul>
          </div>
        </nav>

        <nav id="print" className={getClassNameNavPrint(sidebar, "print")}>
          <div>
            <header>
              <h1>{t("settings.print")}</h1>
              <button onClick={() => controlNavBar("menu")}>
                {t("settings.back")}
              </button>
            </header>
            {audience !== undefined ? (
              <PrintBar
                timeIni={sendComboValues.HrIni + ":" + sendComboValues.MinIni}
                timeFim={sendComboValues.HrFim + ":" + sendComboValues.MinFim}
                onComboChange={handlesendComboChange}
              />
            ) : (
              <div></div>
            )}
            <Link to="#" className="link">
              <div style={{ display: "grid" }}>
                <li className="printbar-btn" onClick={openPrint}>
                  <span>{t("settings.print")}</span>
                  {/* popout now opened programmatically in openPrint() using createRoot */}
                </li>
              </div>
            </Link>
          </div>
        </nav>

        {/* Render Emissora */}
        { }
        <nav id="emissora" className={getClassNameSidebarMenuNav(sidebar, "emissora") + " emissoraNav"}>
          <header className="emissoraNavHeader">
            <h1>{t("secret.settings.columns")}</h1>
            <button id="emissoraBack" onClick={() => controlNavBar("menu")}>
              {t("settings.back")}
            </button>
            <button
              id="emissoraColor"
              style={{
                left: "85%",
                color: "#ff412f",
              }}
              onClick={() => emissoraColorClick(emissoraColorClickObj)}
              title={t("settings.colors")}
            >
              {t("settings.colors")}
            </button>
            <div className="buttonContainer">
              <div className="buttonContainerSave">
                <button id='buttonChannel' onClick={() => clickSaveChannel(setButtonChannel, setChannelButtonEdit, doChangeChannel)} className='buttonSaveChannel' style={{ color: buttonChannel ? '#0D99DB' : 'grey', cursor: buttonChannel ? 'pointer' : 'auto' }}>{t("settings.save")}</button>
              </div>
              <div className="buttonContainerCancel">
                <button id='buttonChannelCancel' onClick={() => clickCancelChannel(setButtonChannel, setChannelButtonEdit, doCancelChangeChannel)} className='buttonCancelChannel' style={{ color: buttonChannel ? 'red' : 'grey', cursor: buttonChannel ? 'pointer' : 'auto' }}>{t("settings.cancel")}</button>
              </div>
            </div>

          </header>
          <ChannelSideBarContext.Provider value={objChannelSideBarContextMemo}>
            <Emissora />
          </ChannelSideBarContext.Provider>
        </nav>

        {/* Render Emissora Color */}
        <nav id="emissoraColor" className={getClassNameSidebarMenuNav(sidebar, "emissoraColor") + " emissoraNav"}>
          <header className="emissoraNavHeader">
            <h1>{t("settings.colors")}</h1>
            <button onClick={() => controlNavBar("emissora")}>
              {t("settings.back")}
            </button>
            <div className="buttonContainer">
              <div className="buttonContainerSave">
                <button
                  id="buttonChannelColor"
                  onClick={() => clickSaveChannelColor(setButtonChannel, setChannelButtonEdit, doChangeColorChannel)}
                  className="buttonSaveChannel"
                  style={{
                    color: buttonChannel ? "#0D99DB" : "grey",
                    cursor: buttonChannel ? "pointer" : "auto",
                  }}
                >
                  {t("settings.save")}
                </button>
              </div>
              <div className="buttonContainerCancel">
                <button
                  id="buttonChannelCancelColor"
                  onClick={() => clickCancelChannelColor(setChannelButtonEdit, setButtonChannel, doCancelChangeChannel)}
                  className="buttonCancelChannel"
                  style={{
                    color: buttonChannel ? "red" : "grey",
                    cursor: buttonChannel ? "pointer" : "auto",
                  }}
                >
                  {t("settings.cancel")}
                </button>
              </div>
            </div>
          </header>
          <ChannelSideBarContext.Provider value={objChannelSideBarContextMemo}>
            <EmissoraColor />
          </ChannelSideBarContext.Provider>
        </nav>
      </menu>
      <ModalSmall
        showModal={error}
        setShowModal={setError}
        title={t("error.warning")}
        text={msgError}
        type="modal-danger"
      />
    </div >
  );
};
export default Sidebar;
